// Device ID Management for Frontend
export const getOrCreateDeviceId = () => {
  let deviceId = localStorage.getItem('device_id');
  
  if (!deviceId) {
    // Generate unique device ID
    deviceId = `device_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('device_id', deviceId);
  }
  
  return deviceId;
};

// Get device info
export const getDeviceInfo = () => {
  return {
    deviceId: getOrCreateDeviceId(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    timestamp: new Date().toISOString()
  };
};

// Reset device ID (for debugging/testing)
export const resetDeviceId = () => {
  localStorage.removeItem('device_id');
};

// Legacy export for backward compatibility
export const getDeviceId = getOrCreateDeviceId;

// Add device ID to all API requests
export const addDeviceIdToRequest = (config) => {
  config.headers['x-device-id'] = getOrCreateDeviceId();
  return config;
};
